module.exports = __webpack_public_path__ + "img/apidays-hongkong-2022-agenda-0825.efef4add.png";